import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslatePipe } from '@ngx-translate/core';
import { Constants } from '../../../../constants/constants';
import { ReviewService } from '../../../../services/review.service';
import { TaskByLevelWithNotes } from '../../../../models/TaskByLevelWithNotes';

@Component({
    selector: 'app-sol-task-by-level',
    imports: [
        CommonModule,
        MatTableModule,
        MatTooltipModule,
        TranslatePipe
    ],
    templateUrl: './sol-task-by-level.component.html',
    styleUrl: './sol-task-by-level.component.scss'
})
export class SolTaskByLevelComponent implements OnInit {
    taskByLevelDetails: TaskByLevelWithNotes[] = [];
    listOfLevelsId: string[] = [];
    listOfTaskTypesObjectOnLevelId: { [key: string]: TaskByLevelWithNotes[] } = {};
    displayedColumnsLabor: string[] = ['taskID', 'taskDescription', 'pmHours', 'engHours', 'cengHours', 'eengHours', 'lengHours', 'nengHours', 'qengHours', 'specHours', 'mechHours', 'elecHours', 'servicingOffice', 'notes'];
    checkDataExists: boolean = true;
    constants = Constants;

    constructor(private readonly reviewService: ReviewService) { }

    ngOnInit(): void {
        this.getTaskByLevelDetails();
    }

    trackByLevel(index: number, level: string): string {
        return level;
    }

    getTaskByLevelDetails() {
        let newCostReviewObject = this.reviewService.newCostReviewObject;
        if (newCostReviewObject && newCostReviewObject.taskByLevelWithNotesDetails) {
            this.taskByLevelDetails = newCostReviewObject.taskByLevelWithNotesDetails;
            this.segragateDataOnTheBasisOfLevelId();
        } else {
            this.checkDataExists = false;
        }
    }

    segragateDataOnTheBasisOfLevelId() {
        this.taskByLevelDetails.forEach((element: TaskByLevelWithNotes, index: number) => {
            element = { ...element, nengHours: this.constants.ZERO, qengHours: this.constants.ZERO, cengHours: this.constants.ZERO, eengHours: this.constants.ZERO, lengHours: this.constants.ZERO };
            if (element.levelDescription) {
                if (!this.listOfLevelsId.includes(`${element.levelDescription}${this.constants.UNDERSCORE}${element.levelID}`)) {
                    this.listOfLevelsId.push(`${element.levelDescription}${this.constants.UNDERSCORE}${element.levelID}`);
                    this.listOfTaskTypesObjectOnLevelId[`${element.levelDescription}${this.constants.UNDERSCORE}${element.levelID}`] = [];
                }
                this.listOfTaskTypesObjectOnLevelId[`${element.levelDescription}${this.constants.UNDERSCORE}${element.levelID}`].push(element);
                if ((index + this.constants.ONE) === this.taskByLevelDetails.length) {
                    this.combineSummaryAndEstimateData();
                    this.calculateSum();
                }
            }
        });
    }

    combineSummaryAndEstimateData() {
        let summaryData: TaskByLevelWithNotes[] = [];
        let estimateData: TaskByLevelWithNotes[] = [];
        let summarySectionName = this.constants.TASK_BY_LEVEL_SUMMARY_LABEL;
        let estimateSectionName = this.constants.TASK_BY_LEVEL_ESTIMATE_LEVEL_LABEL;

        const remainingLevels: string[] = [];

        this.listOfLevelsId.forEach((level: string) => {
            const isSummary = level.includes(this.constants.TASK_BY_LEVEL_SUMMARY_LABEL) || level.includes(this.constants.TASK_BY_LEVEL_SUMMARY_LABEL_FR);
            const isEstimate = level.includes(this.constants.TASK_BY_LEVEL_ESTIMATE_LEVEL_LABEL) || level.includes(this.constants.TASK_BY_LEVEL_ESTIMATE_LEVEL_LABEL_FR);

            if (level.includes(this.constants.TASK_BY_LEVEL_ESTIMATE_LEVEL_LABEL_FR) || level.includes(this.constants.TASK_BY_LEVEL_SUMMARY_LABEL_FR)) {
                summarySectionName = this.constants.TASK_BY_LEVEL_SUMMARY_LABEL_FR;
                estimateSectionName = this.constants.TASK_BY_LEVEL_ESTIMATE_LEVEL_LABEL_FR;
            }

            if (isSummary) {
                summaryData = [...summaryData, ...this.listOfTaskTypesObjectOnLevelId[level]];
                delete this.listOfTaskTypesObjectOnLevelId[level];
                return;
            }

            if (isEstimate) {
                estimateData = [...estimateData, ...this.listOfTaskTypesObjectOnLevelId[level]];
                delete this.listOfTaskTypesObjectOnLevelId[level];
                return;
            }

            remainingLevels.push(level);
        });

        this.listOfLevelsId = [
            `${summarySectionName}${this.constants.UNDERSCORE}${this.constants.ONE}`,
            `${estimateSectionName}${this.constants.UNDERSCORE}${this.constants.ONE}`,
            ...remainingLevels
        ];
        this.listOfTaskTypesObjectOnLevelId[`${estimateSectionName}${this.constants.UNDERSCORE}${this.constants.ONE}`] = estimateData;
        this.listOfTaskTypesObjectOnLevelId[`${summarySectionName}${this.constants.UNDERSCORE}${this.constants.ONE}`] = summaryData;
    }

    calculateSum() {
        this.listOfLevelsId.forEach((level: string) => {
            let totalPMHours = this.constants.ZERO;
            let totalEngHours = this.constants.ZERO;
            let totalNengHours = this.constants.ZERO;
            let totalQengHours = this.constants.ZERO;
            let totalCengHours = this.constants.ZERO;
            let totalEengHours = this.constants.ZERO;
            let totalLengHours = this.constants.ZERO;
            let totalSpecHours = this.constants.ZERO;
            let totalMechHours = this.constants.ZERO;
            let totalElecHours = this.constants.ZERO;
            this.listOfTaskTypesObjectOnLevelId[level].forEach((element: TaskByLevelWithNotes) => {
                totalPMHours += element.pmHours;
                totalEngHours += element.engHours;
                totalNengHours += element.nengHours;
                totalQengHours += element.qengHours;
                totalCengHours += element.cengHours;
                totalEengHours += element.eengHours;
                totalLengHours += element.lengHours;
                totalSpecHours += element.specHours;
                totalMechHours += element.mechHours;
                totalElecHours += element.elecHours;
            });
            let totalRow: TaskByLevelWithNotes = new TaskByLevelWithNotes();
            totalRow.taskDescription = this.constants.TASK_BY_LEVEL_HOURS_TOTAL_LABEL;
            totalRow.pmHours = totalPMHours;
            totalRow.engHours = totalEngHours;
            totalRow.nengHours = totalNengHours;
            totalRow.qengHours = totalQengHours;
            totalRow.cengHours = totalCengHours;
            totalRow.eengHours = totalEengHours;
            totalRow.lengHours = totalLengHours;
            totalRow.specHours = totalSpecHours;
            totalRow.mechHours = totalMechHours;
            totalRow.elecHours = totalElecHours;
            this.listOfTaskTypesObjectOnLevelId[level].push(totalRow);
        });
    }

    getLevelName(level: string): string {
        if (level) {
            return level.split(this.constants.UNDERSCORE)[this.constants.ZERO];
        }
        return this.constants.EMPTY_STRING;

    }

    get isCheckDataExists(): boolean {
        return this.checkDataExists && this.listOfLevelsId.length > Constants.ZERO;
    }

}
